// Passo 5 — resultado da avaliação (CONTRATO-AVM-SITE.md §5).
import type { AvmConfig, AvmResposta, AvmRespostaOk } from '../../lib/avm/types';
import { formatarBRL } from './avm.utils';
import { Icone } from './AvmUI';
import styles from './AvmCalculator.module.css';

const DISCLAIMER_PADRAO =
    'Estimativa automática, gerada a partir de imóveis anunciados na região. Não substitui a avaliação presencial de um corretor.';

export const AvmResultado = ({
    config,
    resposta,
    hrefWhatsapp,
    aoReiniciar,
    aoRevisar,
}: {
    config: AvmConfig;
    resposta: AvmResposta;
    hrefWhatsapp: string | null;
    aoReiniciar: () => void;
    aoRevisar: () => void;
}) => {
    const disclaimer = String((resposta as any)?.disclaimer || DISCLAIMER_PADRAO);

    const ctaWhats = hrefWhatsapp ? (
        <a className={styles.ctaWhats} href={hrefWhatsapp} target="_blank" rel="noopener noreferrer">
            <Icone nome="whatsapp" tamanho={20} />
            {config.ctaWhatsapp}
        </a>
    ) : null;

    // ── não deu para estimar: empty state honesto + o mesmo CTA ──
    if (!resposta || resposta.ok !== true) {
        const mensagem =
            (resposta && typeof resposta.mensagem === 'string' && resposta.mensagem.trim()) ||
            'Ainda não temos imóveis parecidos o bastante na região para calcular uma estimativa confiável. Um corretor consegue te dar esse número com uma visita.';
        return (
            <div aria-live="polite">
                <div className={styles.vazio}>
                    <span className={styles.vazioIcone}>
                        <Icone nome="busca" tamanho={26} />
                    </span>
                    <h4 className={styles.vazioTitulo}>Não conseguimos calcular a estimativa</h4>
                    <p className={styles.vazioTexto}>{mensagem}</p>
                </div>
                {ctaWhats}
                <p className={styles.disclaimer}>{disclaimer}</p>
                <button type="button" className={styles.reiniciar} onClick={aoRevisar}>
                    Revisar os dados do imóvel
                </button>
            </div>
        );
    }

    // ⭐ RESUMIDO de propósito (Daniel 16/09): o visitante vê SÓ o preço aproximado. Nada de
    // faixa, selo de confiança, "como chegamos nesse valor", quantidade de comparáveis ou
    // R$/m² — isso é material do corretor (fica no CRM) e o dono do imóvel lê faixa e
    // confiança como "não sabem o valor". Sem IA nesta tela: o site nunca chama a pesquisa.
    const ok = resposta as AvmRespostaOk;

    return (
        <div aria-live="polite">
            <div className={styles.resultadoTopo}>
                <span className={styles.resultadoEtiqueta}>Preço aproximado de venda</span>
                <strong className={styles.resultadoValor}>{formatarBRL(ok.valorSugerido)}</strong>
            </div>

            <p className={styles.mensagemSucesso}>{config.mensagemSucesso}</p>

            {ctaWhats}

            <p className={styles.disclaimer}>{disclaimer}</p>

            <button type="button" className={styles.reiniciar} onClick={aoReiniciar}>
                Avaliar outro imóvel
            </button>
        </div>
    );
};

export default AvmResultado;
